export default "__VITE_ASSET__d224471e__$_?nuxt_component=async__"